import styled from 'styled-components';

import { FontFamilyMedium } from '../fonts';

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 30px;
`;

export const CircleContainer = styled.div`
    position: relative;
`;

export const LabelContainer = styled.div`
    display: ${props => props.visible ? 'block' : 'none'};
    ${props => props.theme.mediaQueries.desktop} {
        display: block;
    }
    position: absolute;
    left: 50%;
    bottom: -38px;
    transform: translateX(-50%);
    white-space: nowrap;
    text-align: center;
`;

export const Label = styled.p`
    margin: 0;
    ${FontFamilyMedium};
    font-size: 12px;
    color: ${props => props.theme.color.darkBlue};
    text-transform: uppercase;
`;

export const Time = styled.span`
    font-size: 12px;
    text-align: center;
    color: ${props => props.theme.color.gray};
`;

export const Circle = styled.div`
    width: 24px;
    height: 24px;
    border: ${props => props.isCompleted ? 'solid 2px ' + props.theme.color.green : 'solid 2px rgba(63, 80, 99, 0.5)'};
    border-radius: 100%;
    background-color: ${props => props.isActive ? props.theme.color.darkBlue : props.isCompleted ? props.theme.color.green : props.theme.color.white};
`;

export const Line = styled.div`
    flex: 1;
    max-width: 120px;
    background-color: ${props => props.isCompleted ? props.theme.color.green : 'rgba(63, 80, 99, 0.5)'};
    height: 2px;
    margin: 0 4px;
`;